//ALE JAZDA
import React from 'react'
import * as Effects from 'redux-saga/effects'
import openModal from '../../../actions/Modals/openModal'
import { Modals } from '../../../containers/Modals/ModalContainer'
import UpdateModal from '../../../containers/UpdateModal'
import { database } from '../../../database'
import { driver, names } from '../../../database/localStorage'
import { SynchronizeActions } from '../../../reducers/synchronize/actionNames'

function* version(action) {
  const version = driver.getItem(names.UserAccountStorage.Version, '')
  const dbVersion = driver.getItem(names.UserAccountStorage.DbVersion, '')

  if (
    version !== action.version.version ||
    dbVersion !== action.version.dbVersion
  ) {
    yield database.rooms.clear()
    yield database.events.clear()
  }

  if (version && version !== action.version.version) {
    yield Effects.put(openModal(Modals.PrintModal, <UpdateModal />))
  }

  driver.setItem(names.UserAccountStorage.Version, action.version.version)
  driver.setItem(names.UserAccountStorage.DbVersion, action.version.dbVersion)
}

export default function* () {
  yield Effects.takeLatest(SynchronizeActions.Version, version)
}
